import React from "react";
import { Divider, IconButton, SwipeableDrawer, Toolbar } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";

type MuiSwipeableDrawerProps = {
  children: React.ReactNode;
  isOpen: boolean;
  handleDrawerClose: () => void;
  handleDrawerOpen: () => void;
};

const MuiSwipeableDrawer = ({
  children,
  isOpen,
  handleDrawerClose,
  handleDrawerOpen,
}: MuiSwipeableDrawerProps) => {
  return (
    <SwipeableDrawer
      PaperProps={{
        sx: {
          backgroundColor: "primary.main",
          color: "white",
        },
      }}
      anchor="left"
      open={isOpen}
      onClose={() => {
        handleDrawerClose();
      }}
      onOpen={handleDrawerOpen}
    >
      <Toolbar
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          px: [1],
        }}
      >
        <IconButton
          onClick={() => {
            handleDrawerClose();
          }}
        >
          <ChevronLeftIcon sx={{ color: "white" }} />
        </IconButton>
      </Toolbar>
      <Divider />
      {children}
    </SwipeableDrawer>
  );
};

export default MuiSwipeableDrawer;
